import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "./api";
function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault(); // ⛔ stop page reload

    try {
      const response = await fetch(`${API_BASE_URL}/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        navigate("/admin-dashboard"); // ⬅ correct redirect
      } else {
        alert(data.error || "Invalid credentials");
      }
    } catch (error) {
      alert("Network error. Check backend.");
    }
  };

  return (
    <div>
      <h2>Admin Login</h2>

      {/* IMPORTANT: remove form action */}
      <form onSubmit={handleLogin}>

        <input
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit">Login</button>
      </form>
    </div>
  );
}
export default AdminLogin;

